import BaseModel from '../core/BaseModel';

export default class ChatModel extends BaseModel {
  constructor() {
    super(
      {
        name: 'chat',
        tableName: 'chat',
        label: 'Chat'
      }
    );
  }
}
